import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Force a hard reload if the old title is detected, to bypass service worker cache
if (document.title === 'React App') {
  window.location.reload(); 
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister the problematic service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  });
}
